import { render, staticRenderFns } from "./customFixPrice.vue?vue&type=template&id=6f9c6c42&scoped=true&"
import script from "./customFixPrice.vue?vue&type=script&lang=js&"
export * from "./customFixPrice.vue?vue&type=script&lang=js&"
import style0 from "./customFixPrice.vue?vue&type=style&index=0&id=6f9c6c42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c6c42",
  null
  
)

export default component.exports